import { Component, inject } from '@angular/core';
import { VersionService } from '@services/version.service';

@Component({
	selector: 'app-registered-mark',
	imports: [],
	templateUrl: './registered-mark.component.html',
	styleUrl: './registered-mark.component.scss',
})
export class RegisteredMarkComponent {
	public readonly versionService = inject(VersionService);
}
